import type { ModelConfig, Slicer } from '@swf/core/store';
import type { Notification } from '@swf/core/types/Notification';

import { UILayout } from '../enums';

export interface LocalSettingsState {
  documentsSubmitted?: boolean;
  lastLoginAcknowledged?: number;
  layoutMode?: string;
  lowBalancePrompt?: number;
  playingInsights?: number;
  playingInsightsFeedback?: number;
  playSessionLimitGR?: Notification;
  remainingInactivitySeconds?: number;
  restrictPlayingTime?: Notification;
  sessionSummary?: Notification | null;
  showBalance?: boolean;
  validateAccountDaysRO?: number;
}

export interface LocalSettingsModel extends ModelConfig<LocalSettingsState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const defaultState = {
  documentsSubmitted: false,
  layoutMode: UILayout.Table,
  lowBalancePrompt: undefined,
  playingInsights: undefined,
  playingInsightsFeedback: undefined,
  remainingInactivitySeconds: undefined,
  restrictPlayingTime: undefined,
  sessionSummary: null,
  showBalance: true
};

const reducers = {
  set: (state: LocalSettingsState, payload: LocalSettingsState = {}) => ({ ...state, ...payload })
};

const selectors = (slice: Slicer<LocalSettingsState>) => ({
  get() {
    return slice((state) => state || {});
  }
});

const localSettings: LocalSettingsModel = {
  state: defaultState,
  reducers,
  selectors
};

export default localSettings;
